import { render, staticRenderFns } from "./ViewWelcome.vue?vue&type=template&id=113ca7ef&"
import script from "./ViewWelcome.vue?vue&type=script&lang=js&"
export * from "./ViewWelcome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports